import React, { useState } from 'react';
import PersonalData from '../components/SignUp_Flow/PersonalData';
import BrandDataInput from '../components/SignUp_Flow/BrandData'; // Make sure this points to your updated component if necessary
import ConnectStore from '../components/SignUp_Flow/ConnectStore'; // Import your ConnectStore component

function Welcome() {
  const [currentStep, setCurrentStep] = useState('personalData');

  const handleNextStep = () => {
    switch (currentStep) {
      case 'personalData':
        setCurrentStep('brandData');
        break;
      case 'brandData':
        setCurrentStep('connectStore'); // Add this case
        break;
      default:
        break;
      // Handle additional steps if necessary
    }
  };

  const handlePreviousStep = () => {
    switch (currentStep) {
      case 'brandData':
        setCurrentStep('personalData');
        break;
      case 'connectStore': // Add logic to navigate back from the ConnectStore step
        setCurrentStep('brandData');
        break;
      default:
        break;
      // Handle additional steps if necessary
    }
  };

  return (
    <div>
      {currentStep === 'personalData' && <PersonalData onNext={handleNextStep} />}
      {currentStep === 'brandData' && <BrandDataInput onNext={handleNextStep} onPrevious={handlePreviousStep} />}
      {currentStep === 'connectStore' && <ConnectStore onNext={handleNextStep} onPrevious={handlePreviousStep} />} {/* Add this line */}
    </div>
  );
}

export default Welcome;
